import IconBase from '@phosphor-icons/react/dist/lib/IconBase'
import type { IconProps, IconWeight } from '@phosphor-icons/react/dist/lib/types'
import { forwardRef, type ReactElement } from 'react'

// The lower half of Phosphor's CaretUpDown, so a sorted column shows exactly one triangle of the
// unsorted pair, in the same place. Phosphor's own CaretUp/CaretDown are wider and centred.
const weights = new Map<IconWeight, ReactElement>([
  [
    'bold',
    <path
      key="bold"
      d="M184.49,167.51a12,12,0,0,1,0,17l-48,48a12,12,0,0,1-17,0l-48-48a12,12,0,0,1,17-17L128,207l39.51-39.52A12,12,0,0,1,184.49,167.51Z"
    />
  ],
  ['fill', <path key="fill" d="M176,168H80a8,8,0,0,0-5.66,13.66l48,48a8,8,0,0,0,11.32,0l48-48A8,8,0,0,0,176,168Z" />]
])

export const SortDown = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase ref={ref} {...props} weights={weights} />
))
SortDown.displayName = 'SortDown'
